import { ConnectedRouter } from 'connected-react-router/immutable';
import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import ErrorBoundary from 'components/ErrorBoundary';
import { ProjectType } from 'const';
import { AppProps } from 'containers/App/models';
import routes from 'routes';

export const ProjectTypeContext = React.createContext<ProjectType>(undefined);

const App: React.FunctionComponent<AppProps> = ({ history, projectType }) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <ConnectedRouter history={history}>
        <ErrorBoundary>
          <ProjectTypeContext.Provider value={projectType}>
            {routes}
          </ProjectTypeContext.Provider>
        </ErrorBoundary>
      </ConnectedRouter>
    </DndProvider>
  );
};

export default App;
